<template>
  <header class="header">
    <div class="container">
      <div class="header-wrap">
        <div class="logo-group">
          <div class="logo-box">
            <img src="@/assets/logo.jpg" alt="logo"/>
          </div>
          <h1 class="title">昆山市电子信息服务和集成电路行业协会</h1>
        </div>

        <nav class="nav">
          <!-- 首页菜单 -->
          <router-link
              to="/"
              class="nav-item"
              :class="{ active: activeNav === '首页' }"
              @click="handleNavClick('首页')"
              exact
          >
            首页
          </router-link>

          <!-- 关于我们下拉菜单 -->
          <div class="nav-dropdown">
            <router-link
                to="/about"
                class="dropdown-trigger"
                :class="{ active: activeNav === '关于我们' || activeNav === '协会介绍' || activeNav === '协会章程' || activeNav === '加入我们' }"
                @click="handleNavClick('关于我们')"
            >
              关于我们
              <span class="arrow-icon">▼</span>
            </router-link>
            <div class="dropdown-menu">
              <router-link to="/about#intro-anchor" class="dropdown-item" @click="handleNavClick('协会介绍')">协会介绍
              </router-link>
              <router-link to="/about#charter-anchor" class="dropdown-item" @click="handleNavClick('协会章程')">协会章程
              </router-link>
              <router-link to="/about#process-anchor" class="dropdown-item" @click="handleNavClick('加入我们')">加入我们
              </router-link>
              <router-link to="/about#process-download" class="dropdown-item" @click="handleNavClick('资料下载')">资料下载
              </router-link>
            </div>
          </div>

          <!-- 行业资讯 -->
          <router-link
              to="/news"
              class="nav-item"
              :class="{ active: activeNav === '行业资讯' }"
              @click="handleNavClick('行业资讯')"
          >
            行业资讯
          </router-link>

          <!-- 政策法规 -->
          <router-link
              to="/policy"
              class="nav-item"
              :class="{ active: activeNav === '政策法规' }"
              @click="handleNavClick('政策法规')"
          >
            政策法规
          </router-link>

          <!-- 服务指南下拉菜单 -->
          <div class="nav-dropdown">
            <router-link
                to="/services"
                class="dropdown-trigger"
                :class="{ active: activeNav === '服务指南' || activeNav === '双软评估' || activeNav === '软件著作权' || activeNav === '软件产品登记测试' || activeNav === '软件服务商交付能力评估' || activeNav === '信用评估' }"
                @click="handleNavClick('服务指南')"
            >
              服务指南
              <span class="arrow-icon">▼</span>
            </router-link>
            <div class="dropdown-menu">
              <router-link to="/services/soft" class="dropdown-item" @click="handleNavClick('双软评估')">双软评估
              </router-link>
              <router-link to="/services/copyright" class="dropdown-item" @click="handleNavClick('软件著作权')">
                软件著作权
              </router-link>
              <router-link to="/services/test" class="dropdown-item" @click="handleNavClick('软件产品登记测试')">
                软件产品登记测试
              </router-link>
              <router-link to="/services/evaluate" class="dropdown-item"
                           @click="handleNavClick('软件服务商交付能力评估')">软件服务商交付能力评估
              </router-link>
              <router-link to="/services/stat" class="dropdown-item" @click="handleNavClick('信用评估')">信用评估
              </router-link>
            </div>
          </div>

          <!-- 会员名录 -->
          <router-link
              to="/members"
              class="nav-item"
              :class="{ active: activeNav === '会员名录' }"
              @click="handleNavClick('会员名录')"
          >
            会员名录
          </router-link>

          <!-- 联系我们 -->
          <router-link
              to="/contact"
              class="nav-item"
              :class="{ active: activeNav === '联系我们' }"
              @click="handleNavClick('联系我们')"
          >
            联系我们
          </router-link>
        </nav>

        <div class="mobile-btn" @click="isMenuOpen = !isMenuOpen">
          <span>☰</span>
        </div>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div class="mobile-menu" :class="{ hidden: !isMenuOpen }">
      <router-link to="/" class="mobile-item" :class="{ active: activeNav === '首页' }"
                   @click="handleNavClick('首页'); isMenuOpen = false" exact>首页
      </router-link>

      <!-- 移动端关于我们子菜单 -->
      <div class="mobile-dropdown">
        <div class="mobile-dropdown-trigger"
             :class="{ active: activeNav === '关于我们' || activeNav === '协会介绍' || activeNav === '协会章程' || activeNav === '加入我们' }"
             @click="toggleMobileDropdown('about')">
          关于我们
          <span class="arrow-icon" :class="{ rotate: mobileDropdownOpen.about }">▼</span>
        </div>
        <div class="mobile-dropdown-menu" :class="{ show: mobileDropdownOpen.about }">
          <router-link to="/about#intro-anchor" class="mobile-subitem" @click="handleNavClick('协会介绍'); isMenuOpen = false">
            协会介绍
          </router-link>
          <router-link to="/about#charter-anchor" class="mobile-subitem"
                       @click="handleNavClick('协会章程'); isMenuOpen = false">协会章程
          </router-link>
          <router-link to="/about#process-anchor" class="mobile-subitem" @click="handleNavClick('加入我们'); isMenuOpen = false">
            加入我们
          </router-link>
          <router-link to="/about#process-download" class="mobile-subitem" @click="handleNavClick('资料下载'); isMenuOpen = false">
            资料下载
          </router-link>
        </div>
      </div>

      <router-link to="/news" class="mobile-item" :class="{ active: activeNav === '行业资讯' }"
                   @click="handleNavClick('行业资讯'); isMenuOpen = false">行业资讯
      </router-link>
      <router-link to="/policy" class="mobile-item" :class="{ active: activeNav === '政策法规' }"
                   @click="handleNavClick('政策法规'); isMenuOpen = false">政策法规
      </router-link>

      <!-- 移动端服务指南子菜单 -->
      <div class="mobile-dropdown">
        <div class="mobile-dropdown-trigger"
             :class="{ active: activeNav.includes('服务指南') || activeNav === '双软评估' || activeNav === '软件著作权' || activeNav === '软件产品登记测试' || activeNav === '软件服务商交付能力评估' || activeNav === '信用评估' }"
             @click="toggleMobileDropdown('service')">
          服务指南
          <span class="arrow-icon" :class="{ rotate: mobileDropdownOpen.service }">▼</span>
        </div>
        <div class="mobile-dropdown-menu" :class="{ show: mobileDropdownOpen.service }">
          <router-link to="/services/soft" class="mobile-subitem"
                       @click="handleNavClick('双软评估'); isMenuOpen = false">双软评估
          </router-link>
          <router-link to="/services/copyright" class="mobile-subitem"
                       @click="handleNavClick('软件著作权'); isMenuOpen = false">软件著作权
          </router-link>
          <router-link to="/services/test" class="mobile-subitem"
                       @click="handleNavClick('软件产品登记测试'); isMenuOpen = false">软件产品登记测试
          </router-link>
          <router-link to="/services/evaluate" class="mobile-subitem"
                       @click="handleNavClick('软件服务商交付能力评估'); isMenuOpen = false">软件服务商交付能力评估
          </router-link>
          <router-link to="/services/stat" class="mobile-subitem"
                       @click="handleNavClick('信用评估'); isMenuOpen = false">信用评估
          </router-link>
        </div>
      </div>

      <router-link to="/members" class="mobile-item" :class="{ active: activeNav === '会员名录' }"
                   @click="handleNavClick('会员名录'); isMenuOpen = false">会员名录
      </router-link>
      <router-link to="/contact" class="mobile-item" :class="{ active: activeNav === '联系我们' }"
                   @click="handleNavClick('联系我们'); isMenuOpen = false">联系我们
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: "PageNav",
  data() {
    return {
      activeNav: "首页",
      isMenuOpen: false,
      mobileDropdownOpen: { // 移动端下拉菜单状态
        about: false,
        service: false
      }
    };
  },
  watch: {
    // 监听路由变化，自动更新激活态
    $route(to) {
      this.updateActiveNavByRoute(to.path);
    }
  },
  mounted() {
    // 页面初始化时根据当前路由设置激活态
    this.updateActiveNavByRoute(this.$route.path);
  },
  methods: {
    // 根据路由更新激活态
    updateActiveNavByRoute(path) {
      const routeMap = {
        '/': '首页',
        '/about': '关于我们',
        '/about/intro': '协会介绍',
        '/about/history': '协会章程',
        '/about/join': '加入我们',
        '/about#process-download': '资料下载',
        '/news': '行业资讯',
        '/policy': '政策法规',
        '/services': '服务指南',
        '/services/soft': '双软评估',
        '/services/copyright': '软件著作权',
        '/services/test': '软件产品登记测试',
        '/services/evaluate': '软件服务商交付能力评估',
        '/services/stat': '信用评估',
        '/members': '会员名录',
        '/members/detail/:id': '会员名录',
        '/contact': '联系我们'
      };
      if (path.startsWith('/news/detail/')) {
        this.activeNav = '行业资讯';
        return;
      }
      if (path.startsWith('/members/detail/')) {
        this.activeNav = '会员名录';
        return;
      }
      if (path.startsWith('/about/')) {
        this.activeNav = '关于我们';
        return;
      }
      if (path.startsWith('/policy/')) {
        this.activeNav = '政策法规';
        return;
      }
      if (path.startsWith('/services/')) {
        this.activeNav = '服务指南';
        return;
      }
      this.activeNav = routeMap[path] || '首页';
      /*if (path.startsWith('/members/detail/')) {
        this.activeNav = '会员名录';
      } else {
        this.activeNav = routeMap[path] || '首页';
      }*/
    },
    // 处理菜单点击
    handleNavClick(navName) {
      this.activeNav = navName;
      // 点击反馈
      const event = window.event;
      if (event && event.target) {
        event.target.classList.add('click-effect');
        setTimeout(() => {
          event.target.classList.remove('click-effect');
        }, 200);
      }
    },
    // 切换移动端下拉菜单
    toggleMobileDropdown(type) {
      this.mobileDropdownOpen[type] = !this.mobileDropdownOpen[type];
      // 关闭其他下拉菜单
      Object.keys(this.mobileDropdownOpen).forEach(key => {
        if (key !== type) {
          this.mobileDropdownOpen[key] = false;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
// 引入公共样式（根据项目实际路径调整）
@mixin container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}
@mixin transition {
  transition: all 0.3s ease;
}
@mixin hover-blue {
  &:hover {
    color: #1d4ed8;
  }
}

// 变量定义（根据项目实际主题色调整）
$white: #ffffff;
$primary: #1d4ed8;
$blue-900: #1e3a8a;
$slate-100: #f1f5f9;
$slate-600: #475569;

.container {
  @include container;
}

/* 头部 */
.header {
  background: $white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  //position: relative;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}

.header-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.logo-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-box {
  width: 48px;
  height: 48px;
  background: $primary;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.title {
  font-size: 18px;
  color: $blue-900;
  font-weight: 600;
  white-space: nowrap;
}

.nav {
  display: flex;
  gap: 30px;
}

.nav-item {
  font-size: 16px;
  color: $slate-600;
  cursor: pointer;
  @include transition;
  text-decoration: none;

  // 激活态
  &.active {
    color: $primary;
    font-weight: bold;
    position: relative;
  }

  // 激活态下划线
  &.active::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: $primary;
    border-radius: 1px;
  }

  &:hover {
    color: $primary;
  }

  // 点击态效果
  &.click-effect {
    transform: scale(0.95);
    opacity: 0.8;
  }
}

.nav-dropdown {
  position: relative;
  display: inline-block;
  font-weight: bold;

  .dropdown-trigger {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 10px;
    font-size: 16px;
    color: #475569;
    transition: color 0.3s ease;
    text-decoration: none;

    // 下拉菜单激活态
    &.active {
      color: $primary;
      font-weight: bold;
    }

    &:hover {
      color: #1d4ed8;
    }

    // 点击态效果
    &.click-effect {
      transform: scale(0.95);
      opacity: 0.8;
    }

    .arrow-icon {
      margin-left: 6px;
      font-size: 12px;
      transition: transform 0.3s ease;
    }
  }

  .dropdown-menu {
    min-width: 220px;
    position: absolute;
    top: 100%;
    left: 0;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 8px 8px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(8px);
    transition: all 0.3s ease;
    padding: 8px 0;
    text-align: left !important;
    z-index: 1000;

    .dropdown-item {
      display: block;
      padding: 8px 16px;
      font-size: 14px;
      color: #475569;
      text-align: left !important;
      transition: all 0.3s ease;
      text-decoration: none;

      &:hover {
        color: #1d4ed8;
        background: #f8fafc;
      }

      // 下拉菜单项点击态
      &.click-effect {
        background: #e0e7ff;
        transform: translateX(2px);
      }
    }
  }

  &:hover {
    .arrow-icon {
      transform: rotate(180deg);
    }

    .dropdown-menu {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
}

.mobile-btn {
  font-size: 24px;
  cursor: pointer;
  display: none;
  color: $slate-600;
  transition: all 0.3s ease;

  &:hover {
    color: $primary;
  }
}

.mobile-menu {
  padding: 20px;
  background: $white;
  border-top: 1px solid $slate-100;
  display: none;

  &.hidden {
    display: none;
  }

  &:not(.hidden) {
    display: block;
  }
}

.mobile-item {
  display: block;
  padding: 12px 0;
  color: $slate-600;
  transition: all 0.2s ease;
  text-decoration: none;
  font-size: 16px;

  // 移动端菜单激活态
  &.active {
    color: $primary;
    font-weight: bold;
    padding-left: 8px;
    border-left: 3px solid $primary;
  }

  // 移动端菜单点击态
  &.click-effect {
    background: #f0f7ff;
    transform: scale(0.98);
    border-radius: 4px;
  }
}

// 移动端下拉菜单样式
.mobile-dropdown {
  margin: 8px 0;

  .mobile-dropdown-trigger {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    color: $slate-600;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s ease;

    &.active {
      color: $primary;
      font-weight: bold;
      padding-left: 8px;
      border-left: 3px solid $primary;
    }

    .arrow-icon {
      font-size: 12px;
      transition: transform 0.3s ease;

      &.rotate {
        transform: rotate(180deg);
      }
    }
  }

  .mobile-dropdown-menu {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    padding-left: 16px;

    &.show {
      max-height: 500px;
    }
  }

  .mobile-subitem {
    display: block;
    padding: 8px 0;
    color: $slate-600;
    font-size: 14px;
    text-decoration: none;
    transition: all 0.2s ease;

    &:hover {
      color: $primary;
      padding-left: 4px;
    }
  }
}

// 响应式适配
@media (max-width: 768px) {
  .header-wrap {
    height: 70px;
  }

  .logo-box {
    width: 40px;
    height: 40px;
  }

  .title {
    font-size: 14px;
  }

  .nav {
    display: none;
  }

  .mobile-btn {
    display: block;
  }

  .mobile-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    z-index: 998;
  }
}

@media (max-width: 480px) {
  .title {
    display: none;
  }
}
</style>
